/**
 * 音声関連のユーティリティ関数
 */

import { logger } from '@/lib/logger';

/**
 * 音声Blobの長さ（秒）を取得する
 */
export function getAudioDuration(blob: Blob): Promise<number> {
  return new Promise((resolve, reject) => {
    const audio = new Audio();
    audio.src = URL.createObjectURL(blob);

    audio.onloadedmetadata = () => {
      URL.revokeObjectURL(audio.src);
      resolve(audio.duration);
    };

    audio.onerror = () => {
      logger.error('音声ファイルの読み込みに失敗しました', new Error('Audio load failed'), {
        blobType: blob.type,
        blobSize: blob.size,
      });
      URL.revokeObjectURL(audio.src);
      reject(new Error('音声ファイルの読み込みに失敗しました'));
    };
  });
}
